import { render } from "./LoginLicense.vue?vue&type=template&id=47e01670&scoped=true"
import script from "./LoginLicense.vue?vue&type=script&lang=js"
export * from "./LoginLicense.vue?vue&type=script&lang=js"

import "./LoginLicense.vue?vue&type=style&index=0&id=47e01670&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e01670"]])

export default __exports__